import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    create({commit}, invoiceNoteForm) {
      return new Promise((resolve, reject) => {
        axios
          .post('/supply-chains/po-invoices', invoiceNoteForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, invoiceNoteForm) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/po-invoices/${invoiceNoteForm.get('id')}`, invoiceNoteForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    check({commit}, poInvoiceId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/po-invoices/${poInvoiceId}/check`)
          .then(res => {
            resolve(res.data.data.status)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    verify({commit}, verifyData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/po-invoices/${verifyData.id}/verify`, verifyData)
          .then(res => {
            resolve(res.data.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    revert({commit}, poInvoiceId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/supply-chains/po-invoices/${poInvoiceId}/revert`)
          .then(res => {
            resolve(res.data.data.status)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getItemDetails({commit}, {itemId, poInvoiceId}) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/supply-chains/po-invoices/items/${itemId}/get-details`, {
            params: {
              po_invoice_id: poInvoiceId
            }
          })
          .then(res => {
            resolve(res.data.data.details)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    getPrintData({commit}, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/supply-chains/po-invoices/${id}/print-data`)
          .then(res => {
            resolve(res.data.data.items)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
